import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { InputComboBox } from '@goodfynd/forms';

import { PICKUP_CAPACITY_OPTIONS } from './helpers';
import type { InputPickupCapacityProps } from './types';
export const DEFAULT_PICKUP_CAPACITY = 3;

export function InputPickupCapacity<
  T extends FieldValues = { pickupCapacity: number }
>({
  className,
  options = PICKUP_CAPACITY_OPTIONS,
  ...props
}: InputPickupCapacityProps<T>) {
  return (
    <InputComboBox<T>
      className={className}
      css={{ paddingBottom: 0 }}
      freeSolo
      helperText="How many orders can you prepare and serve in a 15 minute period?"
      inputMode="numeric"
      label="Pickup capacity"
      mask="999"
      options={options}
      {...props}
    />
  );
}
